import { useMemo } from "react";

import { getResourceIRI } from "@sol/sdk";
import { useLocationListQuery } from "@sol/sdk/locations";
import { Select, type SelectProps } from "@sol/uikit/data-entry/Select/Select";

type Props = SelectProps;

export function LocationSelect({ ...rest }: Props) {
    const { data, isLoading } = useLocationListQuery({}, { useErrorBoundary: true, suspense: false });
    const options = useMemo(
        () =>
            data?.["hydra:member"].map(location => ({
                label: location.title,
                value: getResourceIRI(location),
            })) ?? [],
        [data],
    );

    return <Select {...rest} options={options} loading={isLoading} />;
}
